import Nullstack from 'nullstack';
export default function IconBrandNpm({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-npm",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M1 8h22v7h-12v2h-4v-2h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v7"
  }), "   ", Nullstack.element("path", {
    d: "M14 8v7"
  }), "   ", Nullstack.element("path", {
    d: "M17 11v4"
  }), "   ", Nullstack.element("path", {
    d: "M4 11v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 11v1"
  }), "   ", Nullstack.element("path", {
    d: "M20 11v4"
  }), " ");
}